export enum PaymentType {
  Undefined = 0,
  Credits = 1,
  Subscription = 2
}
